import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["display", "disabled"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledImage = styled.img.withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-1do0gql-0"
})(({
  $cssStyles,
  $disabled
}) => {
  return Object.assign({}, $cssStyles, {
    boxSizing: 'border-box',
    opacity: $disabled ? 0.5 : 1
  });
});
export const Image = _ref => {
  let {
      display = 'inline-block',
      disabled = false
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(Object.assign({}, restProps, {
    display
  }), {
    isImage: true
  });
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledImage, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $disabled: disabled
  }));
};